import AOS from "aos";
import { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import "../src/assets/scss/aos.css";
import "../src/assets/scss/fonts.css";
import "../src/assets/scss/style.scss";
import Naigation from "./components/NavRouting";

function App() {
  useEffect(() => {
    AOS.init({
      duration: 600,
      once: false,
    });
  }, []);
  return (
    <BrowserRouter>
      <Naigation />
    </BrowserRouter>
  );
}

export default App;
